/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type AppUserQueryRendererQueryVariables = {
    auIntercomId: string;
    aroundTripUUID?: string | null;
};
export type AppUserQueryRendererQueryResponse = {
    readonly appuserByIntercomId: {
        readonly " $fragmentRefs": FragmentRefs<"AppUserOverview_appuser">;
    } | null;
};
export type AppUserQueryRendererQuery = {
    readonly response: AppUserQueryRendererQueryResponse;
    readonly variables: AppUserQueryRendererQueryVariables;
};



/*
query AppUserQueryRendererQuery(
  $auIntercomId: UUID!
  $aroundTripUUID: String
) {
  appuserByIntercomId(intercomId: $auIntercomId) {
    ...AppUserOverview_appuser_2PNN60
    id
  }
}

fragment AppUserOverview_appuser_2PNN60 on AppUserNode {
  id
  deleted
  intercomExternalUserId
  isInternalUser
  firstLogs: logs(first: 1) {
    edges {
      node {
        id
        ...LogViewer_log
      }
    }
  }
  firstTrips: apptrips(first: 1) {
    edges {
      node {
        id
        ...TripViewer_trip
      }
    }
  }
  ltruser {
    email
    id
  }
  ...LogList_appuser
  ...PrivacyAuthorizationList_appuser
  ...TripList_appuser_3ETXda
  latestDevice: iosDevices(first: 1) {
    edges {
      node {
        id
        ...IosDeviceViewer_iosDevice
      }
    }
  }
}

fragment IosDeviceViewer_iosDevice on IOSDeviceStatusNode {
  id
  firstSeen
  firstSeenClient {
    userAgent
    platform
    version
    build
    deviceModel
    iosDistributionMethod
  }
  lastSeen
  lastSeenClient {
    userAgent
    platform
    version
    build
    deviceModel
    iosDistributionMethod
  }
  currentTimeZoneId
  currentTimeZoneOffset
}

fragment LogList_appuser on AppUserNode {
  id
  logs(first: 10) {
    edges {
      node {
        id
        createdOnDevice
        modifiedOnDevice
        platform
        ...LogViewer_log
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment LogViewer_log on AppLogNode {
  id
  firstSeen
  createdOnDevice
  modifiedOnDevice
  sha256Hexdigest
  platform
  authorizedLogLinesUrl
}

fragment PredictionAggregatorsList_predictionAggregators on PredictionAggregator {
  predictions {
    startDate
    activityPredictionModelIdentifier
    predictedActivities {
      activityType
      confidence
    }
  }
  aggregatePredictedActivity {
    activityType
    confidence
  }
}

fragment PrivacyAuthorizationList_appuser on AppUserNode {
  privacyAuthorizations(first: 10) {
    edges {
      node {
        id
        historyStart
        historyEnd
        notValidAfter
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  id
}

fragment TripList_appuser_3ETXda on AppUserNode {
  id
  apptrips(first: 5, aroundTripUUID: $aroundTripUUID) {
    edges {
      node {
        id
        uuid
        ...TripList_trip
        ...TripViewer_trip
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}

fragment TripList_trip on TripNode {
  id
  uuid
  utcoffset
  isDeleted
  isExcluded
  excludedReason
  created
  modified
  localStartDate
  localEndDate
  computedLengthMeters
  computedActivityType
  enteredActivityType
  computedMapBounds
  routeData {
    routeIds
    earliestFirstSeen
    latestFirstSeen
  }
  client {
    platform
    deviceModel
    userAgent
    version
    build
  }
}

fragment TripViewer_trip on TripNode {
  id
  uuid
  utcoffset
  isDeleted
  isExcluded
  excludedReason
  created
  modified
  localStartDate
  localEndDate
  computedLengthMeters
  computedActivityType
  enteredActivityType
  computedMapBounds
  computedStartLocationDescription
  computedEndLocationDescription
  routeData {
    preparedLocations
    rawLocations
  }
  routes {
    creationDate
    closedDate
    tossed
    tossedDate
    tossedReason
    summaryLocations
    deleted
    activityType
    originalLengthMeters
    predictionAggregators {
      aggregatePredictedActivity {
        confidence
        activityType
      }
      predictions {
        startDate
      }
      ...PredictionAggregatorsList_predictionAggregators
    }
    id
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "aroundTripUUID"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "auIntercomId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "intercomId",
    "variableName": "auIntercomId"
  }
],
v3 = {
  "kind": "Variable",
  "name": "aroundTripUUID",
  "variableName": "aroundTripUUID"
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deleted",
  "storageKey": null
},
v6 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  }
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstSeen",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdOnDevice",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "modifiedOnDevice",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sha256Hexdigest",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "platform",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "authorizedLogLinesUrl",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uuid",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "utcoffset",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isDeleted",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isExcluded",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "excludedReason",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "created",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "modified",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "localStartDate",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "localEndDate",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "computedLengthMeters",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "computedActivityType",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "enteredActivityType",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "computedMapBounds",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "computedStartLocationDescription",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "computedEndLocationDescription",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "preparedLocations",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rawLocations",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "activityType",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "confidence",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "concreteType": "RouteNode",
  "kind": "LinkedField",
  "name": "routes",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "creationDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "closedDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tossed",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tossedDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tossedReason",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "summaryLocations",
      "storageKey": null
    },
    (v5/*: any*/),
    (v30/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "originalLengthMeters",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PredictionAggregator",
      "kind": "LinkedField",
      "name": "predictionAggregators",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PredictedActivity",
          "kind": "LinkedField",
          "name": "aggregatePredictedActivity",
          "plural": false,
          "selections": [
            (v31/*: any*/),
            (v30/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Prediction",
          "kind": "LinkedField",
          "name": "predictions",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "startDate",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "activityPredictionModelIdentifier",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "PredictedActivity",
              "kind": "LinkedField",
              "name": "predictedActivities",
              "plural": true,
              "selections": [
                (v30/*: any*/),
                (v31/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v4/*: any*/)
  ],
  "storageKey": null
},
v33 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  }
],
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endCursor",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasNextPage",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    (v36/*: any*/),
    (v37/*: any*/)
  ],
  "storageKey": null
},
v39 = [
  (v3/*: any*/),
  {
    "kind": "Literal",
    "name": "first",
    "value": 5
  }
],
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deviceModel",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userAgent",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "version",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "build",
  "storageKey": null
},
v44 = [
  (v41/*: any*/),
  (v11/*: any*/),
  (v42/*: any*/),
  (v43/*: any*/),
  (v40/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "iosDistributionMethod",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AppUserQueryRendererQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "AppUserNode",
        "kind": "LinkedField",
        "name": "appuserByIntercomId",
        "plural": false,
        "selections": [
          {
            "args": [
              (v3/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "AppUserOverview_appuser"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "AppUserQueryRendererQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "AppUserNode",
        "kind": "LinkedField",
        "name": "appuserByIntercomId",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "intercomExternalUserId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isInternalUser",
            "storageKey": null
          },
          {
            "alias": "firstLogs",
            "args": (v6/*: any*/),
            "concreteType": "AUAppLogConnection",
            "kind": "LinkedField",
            "name": "logs",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AppLogNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AppLogNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/),
                      (v11/*: any*/),
                      (v12/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "logs(first:1)"
          },
          {
            "alias": "firstTrips",
            "args": (v6/*: any*/),
            "concreteType": "AUAppTripConnection",
            "kind": "LinkedField",
            "name": "apptrips",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "TripNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TripNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v13/*: any*/),
                      (v14/*: any*/),
                      (v15/*: any*/),
                      (v16/*: any*/),
                      (v17/*: any*/),
                      (v18/*: any*/),
                      (v19/*: any*/),
                      (v20/*: any*/),
                      (v21/*: any*/),
                      (v22/*: any*/),
                      (v23/*: any*/),
                      (v24/*: any*/),
                      (v25/*: any*/),
                      (v26/*: any*/),
                      (v27/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RouteDataObject",
                        "kind": "LinkedField",
                        "name": "routeData",
                        "plural": false,
                        "selections": [
                          (v28/*: any*/),
                          (v29/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v32/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "apptrips(first:1)"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "LtrUserNode",
            "kind": "LinkedField",
            "name": "ltruser",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "email",
                "storageKey": null
              },
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v33/*: any*/),
            "concreteType": "AUAppLogConnection",
            "kind": "LinkedField",
            "name": "logs",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AppLogNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AppLogNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v11/*: any*/),
                      (v7/*: any*/),
                      (v10/*: any*/),
                      (v12/*: any*/),
                      (v34/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v35/*: any*/)
                ],
                "storageKey": null
              },
              (v38/*: any*/)
            ],
            "storageKey": "logs(first:10)"
          },
          {
            "alias": null,
            "args": (v33/*: any*/),
            "filters": null,
            "handle": "connection",
            "key": "LogList_logs",
            "kind": "LinkedHandle",
            "name": "logs"
          },
          {
            "alias": null,
            "args": (v33/*: any*/),
            "concreteType": "AUAppDataPrivacyAuthorizationConnection",
            "kind": "LinkedField",
            "name": "privacyAuthorizations",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AppDataPrivacyAuthorizationNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AppDataPrivacyAuthorizationNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "historyStart",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "historyEnd",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "notValidAfter",
                        "storageKey": null
                      },
                      (v34/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v35/*: any*/)
                ],
                "storageKey": null
              },
              (v38/*: any*/)
            ],
            "storageKey": "privacyAuthorizations(first:10)"
          },
          {
            "alias": null,
            "args": (v33/*: any*/),
            "filters": null,
            "handle": "connection",
            "key": "PrivacyAuthorizationList_privacyAuthorizations",
            "kind": "LinkedHandle",
            "name": "privacyAuthorizations"
          },
          {
            "alias": null,
            "args": (v39/*: any*/),
            "concreteType": "AUAppTripConnection",
            "kind": "LinkedField",
            "name": "apptrips",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "TripNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TripNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v13/*: any*/),
                      (v14/*: any*/),
                      (v15/*: any*/),
                      (v16/*: any*/),
                      (v17/*: any*/),
                      (v18/*: any*/),
                      (v19/*: any*/),
                      (v20/*: any*/),
                      (v21/*: any*/),
                      (v22/*: any*/),
                      (v23/*: any*/),
                      (v24/*: any*/),
                      (v25/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RouteDataObject",
                        "kind": "LinkedField",
                        "name": "routeData",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "routeIds",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "earliestFirstSeen",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "latestFirstSeen",
                            "storageKey": null
                          },
                          (v28/*: any*/),
                          (v29/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ClientObject",
                        "kind": "LinkedField",
                        "name": "client",
                        "plural": false,
                        "selections": [
                          (v11/*: any*/),
                          (v40/*: any*/),
                          (v41/*: any*/),
                          (v42/*: any*/),
                          (v43/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v26/*: any*/),
                      (v27/*: any*/),
                      (v32/*: any*/),
                      (v34/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v35/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  (v36/*: any*/),
                  (v37/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasPreviousPage",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "startCursor",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v39/*: any*/),
            "filters": [
              "aroundTripUUID"
            ],
            "handle": "connection",
            "key": "TripList_apptrips",
            "kind": "LinkedHandle",
            "name": "apptrips"
          },
          {
            "alias": "latestDevice",
            "args": (v6/*: any*/),
            "concreteType": "AUIOSDeviceStatusConnection",
            "kind": "LinkedField",
            "name": "iosDevices",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "IOSDeviceStatusNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "IOSDeviceStatusNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v7/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ClientObject",
                        "kind": "LinkedField",
                        "name": "firstSeenClient",
                        "plural": false,
                        "selections": (v44/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "lastSeen",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ClientObject",
                        "kind": "LinkedField",
                        "name": "lastSeenClient",
                        "plural": false,
                        "selections": (v44/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "currentTimeZoneId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "currentTimeZoneOffset",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "iosDevices(first:1)"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "023bed19aa3fbfb97f1be1f0e7a0d882",
    "id": null,
    "metadata": {},
    "name": "AppUserQueryRendererQuery",
    "operationKind": "query",
    "text": "query AppUserQueryRendererQuery(\n  $auIntercomId: UUID!\n  $aroundTripUUID: String\n) {\n  appuserByIntercomId(intercomId: $auIntercomId) {\n    ...AppUserOverview_appuser_2PNN60\n    id\n  }\n}\n\nfragment AppUserOverview_appuser_2PNN60 on AppUserNode {\n  id\n  deleted\n  intercomExternalUserId\n  isInternalUser\n  firstLogs: logs(first: 1) {\n    edges {\n      node {\n        id\n        ...LogViewer_log\n      }\n    }\n  }\n  firstTrips: apptrips(first: 1) {\n    edges {\n      node {\n        id\n        ...TripViewer_trip\n      }\n    }\n  }\n  ltruser {\n    email\n    id\n  }\n  ...LogList_appuser\n  ...PrivacyAuthorizationList_appuser\n  ...TripList_appuser_3ETXda\n  latestDevice: iosDevices(first: 1) {\n    edges {\n      node {\n        id\n        ...IosDeviceViewer_iosDevice\n      }\n    }\n  }\n}\n\nfragment IosDeviceViewer_iosDevice on IOSDeviceStatusNode {\n  id\n  firstSeen\n  firstSeenClient {\n    userAgent\n    platform\n    version\n    build\n    deviceModel\n    iosDistributionMethod\n  }\n  lastSeen\n  lastSeenClient {\n    userAgent\n    platform\n    version\n    build\n    deviceModel\n    iosDistributionMethod\n  }\n  currentTimeZoneId\n  currentTimeZoneOffset\n}\n\nfragment LogList_appuser on AppUserNode {\n  id\n  logs(first: 10) {\n    edges {\n      node {\n        id\n        createdOnDevice\n        modifiedOnDevice\n        platform\n        ...LogViewer_log\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment LogViewer_log on AppLogNode {\n  id\n  firstSeen\n  createdOnDevice\n  modifiedOnDevice\n  sha256Hexdigest\n  platform\n  authorizedLogLinesUrl\n}\n\nfragment PredictionAggregatorsList_predictionAggregators on PredictionAggregator {\n  predictions {\n    startDate\n    activityPredictionModelIdentifier\n    predictedActivities {\n      activityType\n      confidence\n    }\n  }\n  aggregatePredictedActivity {\n    activityType\n    confidence\n  }\n}\n\nfragment PrivacyAuthorizationList_appuser on AppUserNode {\n  privacyAuthorizations(first: 10) {\n    edges {\n      node {\n        id\n        historyStart\n        historyEnd\n        notValidAfter\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment TripList_appuser_3ETXda on AppUserNode {\n  id\n  apptrips(first: 5, aroundTripUUID: $aroundTripUUID) {\n    edges {\n      node {\n        id\n        uuid\n        ...TripList_trip\n        ...TripViewer_trip\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n      hasPreviousPage\n      startCursor\n    }\n  }\n}\n\nfragment TripList_trip on TripNode {\n  id\n  uuid\n  utcoffset\n  isDeleted\n  isExcluded\n  excludedReason\n  created\n  modified\n  localStartDate\n  localEndDate\n  computedLengthMeters\n  computedActivityType\n  enteredActivityType\n  computedMapBounds\n  routeData {\n    routeIds\n    earliestFirstSeen\n    latestFirstSeen\n  }\n  client {\n    platform\n    deviceModel\n    userAgent\n    version\n    build\n  }\n}\n\nfragment TripViewer_trip on TripNode {\n  id\n  uuid\n  utcoffset\n  isDeleted\n  isExcluded\n  excludedReason\n  created\n  modified\n  localStartDate\n  localEndDate\n  computedLengthMeters\n  computedActivityType\n  enteredActivityType\n  computedMapBounds\n  computedStartLocationDescription\n  computedEndLocationDescription\n  routeData {\n    preparedLocations\n    rawLocations\n  }\n  routes {\n    creationDate\n    closedDate\n    tossed\n    tossedDate\n    tossedReason\n    summaryLocations\n    deleted\n    activityType\n    originalLengthMeters\n    predictionAggregators {\n      aggregatePredictedActivity {\n        confidence\n        activityType\n      }\n      predictions {\n        startDate\n      }\n      ...PredictionAggregatorsList_predictionAggregators\n    }\n    id\n  }\n}\n"
  }
};
})();
(node as any).hash = 'e85bf3773db4ccb8a8bb4e772b6efdb5';
export default node;
